<template>
  <div class="categories">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-md-12 d-block d-sm-flex justify-content-between align-items-center">
            <h1 class="fw-600 fs-24 mb-0">Categorias</h1>
            <button class="btn btn-blue my-3 my-sm-0" data-toggle="modal" @click="openCreateModal()">
              Nova Categoria
            </button>
          </div>
        </div>
        <div class="table-responsive mt-1">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Nome</th>
                <th>Descrição</th>
                <th>Categoria Pai</th>
                <th>Imagem</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="category in categories.data" :key="category.id">
                <td class="align-middle body-table">
                    {{ category.id }}
                </td>
                <th class="align-middle body-table">
                    {{ category.description }}
                </th>
                <td class="align-middle body-table">
                  {{ category.slug }}
                </td>
                <td class="align-middle body-table">
                  {{ category.parent ? category.parent.description : '-' }}
                </td>
                <td class="align-middle body-table">
                  <button class="btn" @click="openFileModal(category)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 640 512">
                      <path d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"/>
                    </svg>
                  </button>
                </td>
                <td class="align-middle body-table">
                  <button class="btn mr-2" data-toggle="modal" @click="openUpdateModal(category)">
                    <i class="far fa-edit"></i>
                  </button>
                  <button class="btn" data-toggle="modal" @click="openDeleteModal(category)">
                    <i class="fas fa-times text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <PaginateComponent :source="pagination" @navigate="navigate"/>
        </div>
      </div>
    </div>
    <LoadingComponent :loading="loading || !categories.data" />

    <!-- Register Modal -->
    <div class="modal fade" id="CreateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ (category.id ? 'Editar Categoria' : 'Cadastrar Categoria')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label class="form-control-label">Nome:</label>
                    <input type="text" class="form-control" v-model="category.description" required>
                  </div>
                  <div class="col">
                    <label class="form-control-label">URL Slug:</label>
                    <input type="text" class="form-control" v-model="category.slug" required>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Vincular a um cupom:</label>
                    <select class="form-control" v-model="category.coupon_id" required>
                      <option :value="null"> - Selecione - </option>
                      <option v-for="coupon in coupons.data" :key="coupon.id" :value="coupon.id">{{ coupon.description }}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Vincular com outra categoria:</label>
                    <select class="form-control" v-model="category.parent_id" required>
                      <option :value="null"> - Selecione - </option>
                      <option v-for="category in categories.data" :key="category.id" :value="category.id">{{ category.description }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="updateCategory()" v-if="category.id">Editar Categoria</button>
            <button type="button" class="btn btn-success" @click="addCategory()" v-else>Cadastrar Categoria</button>
          </div>
        </div>
      </div>
    </div>
    <!-- DELETE MODAL -->
      <div class="modal fade" id="openDeleteModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h3 class="modal-title" id="exampleModalLabel">Excluir Categoria</h3>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      Deseja excluir o categoria?
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-dark" data-dismiss="modal">Fechar</button>
                      <button type="button" class="btn btn-danger" @click="deleteCategory()">Excluir</button>
                  </div>
              </div>
          </div>
      </div>
    <!-- file MODAL -->
      <div class="modal fade" id="openFileModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-centered modal-lg" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h3 class="modal-title" id="exampleModalLabel">Imagem</h3>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <h3 class="text-white">Imagens</h3>
                      </div>
                      <div class="col-md-6 text-right">
                        <button v-if="img" class="btn btn-warning text-uppercase px-3 py-3" @click="crop()">
                          CORTAR
                        </button>
                        <input v-else type="file" ref="file" class="form-control" @change="uploadImage($event)" accept="image/*">
                      </div>
                      <div class="col-md-12">
                        <div class="row">
                          <div v-for="(file, i) in category.files" :key="file.id" class="col-md-3 mt-3">
                            <div class="delete">
                              <img :src="file.url" class="w-100" alt="">
                              <button class="btn" @click="deleteImageInArray(i)">
                                <i class="fas fa-trash-alt pos text-danger"></i>
                              </button>
                            </div>
                          </div>
                          <div v-for="file in data.files" :key="file.id" class="col-md-3 mt-3">
                            <div class="delete">
                              <img :src="file.url" class="w-100" alt="">
                              <button class="btn" @click="deleteImageInArray(i)">
                                <i class="fas fa-trash-alt pos text-danger"></i>
                              </button>
                            </div>
                          </div>
                          <div v-if="img" class="col-md-3 mt-3">
                            <Cropper
                              :restrictions="pixelsRestriction"
                              :src="img"
                              ref="cropper"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-dark" data-dismiss="modal">Fechar</button>
                      <button class="btn btn-success" @click="save()">Salvar Alterações</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import LoadingComponent from '../../components/layout/LoadingComponent'
import PaginateComponent from '../../components/PaginateComponent'
import { Cropper } from 'vue-advanced-cropper'

export default {

  name: 'IndexCategoriesPage',

  components: {
    Cropper,
    PaginateComponent,
    LoadingComponent
  },

  computed: mapState({
    categories: state => state.categories.data,
    coupons: state => state.coupons.data,
    pagination: state => state.categories.pagination,
    loading: state => state.categories.loading
  }),

  data: function () {
    return {
      category: {
        id: null,
        description: null,
        slug: null,
        parent_id: null,
        coupon_id: null
      },
      destroy_category: null,
      data: {
        company_category_id: null, // você define via props ou rota
        files: [], // arquivos com link (base64 ou real URL)
        type: 1 // ou 'Video Commerce', se for o caso
      },
      img: null,
      coordinates: null
      // pixelsRestriction: {
      //   width: 800,
      //   height: 800
      // }
    }
  },

  methods: {

    ...mapActions('categories', [
      'index',
      'store',
      'update',
      'destroy',
      'storeFiles'
    ]),

    ...mapActions('coupons', [
      'getCoupons'
    ]),

    addCategory: function () {
      this.store(this.category)
      $('#CreateModal').modal('hide')
    },

    searchWithPaginate (page) {
      this.index({ page: page, search: this.search })
    },

    navigate (page) {
      this.searchWithPaginate(page)
    },

    openCreateModal: function () {
      this.category = {
        description: null,
        slug: null,
        coupon_id: null,
        parent_id: null
      }
      $('#CreateModal').modal()
    },

    openUpdateModal: function (category) {
      this.category = category
      $('#CreateModal').modal()
    },

    openDeleteModal: function (category) {
      this.destroy_category = category
      $('#openDeleteModal').modal()
    },

    openFileModal: function (category) {
      this.category = category
      $('#openFileModal').modal()
    },

    updateCategory: function () {
      this.update({ id: this.category.id, data: this.category })
      $('#CreateModal').modal('hide')
    },

    deleteCategory: function () {
      this.destroy(this.destroy_category.id)
      $('#openDeleteModal').modal('hide')
    },

    pixelsRestriction ({ minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight }) {
      this.errorImage = null

      // se a imagem for menor que 200px
      if (imageHeight < 200 || imageWidth < 200) {
        this.errorImage = 'Essa imagem é muito pequena. Para melhor visualização do produto, opte por imagens com dimensões superiores a 600x600 px'
        return false

      // se a imagem for maior que 200px e menor que 600px
      } else if (imageHeight < 600 || imageWidth < 600) {
        this.errorImage = 'Dica: Para melhor visualização do produto, opte por imagens com dimensões superiores a 600px x 600px'
        return {
          minWidth: minWidth,
          minHeight: minHeight,
          maxWidth: Math.min(imageWidth, maxWidth),
          maxHeight: Math.min(imageHeight, maxHeight)
        }
      }
    },

    uploadImage (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.img = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    crop () {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      // const { canvas } = this.$refs.cropper.getResult()
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      this.data.files.push({
        id: Date.now(),
        url: canvas.toDataURL(),
        type: this.data.type || 1
      })
      this.img = null
    },

    save () {
      try {
        const newFiles = this.data.files.map(file => ({
          id: null,
          url: file.url,
          type: file.type
        }))

        const files = this.category.files.map(file => ({
          id: file.id,
          url: file.url,
          type: file.type
        }))

        const payload = {
          company_category_id: this.category.id,
          files: [
            ...files,
            ...newFiles
          ]
        }

        this.storeFiles(payload)
        // alert('Arquivos enviados com sucesso!')
        // this.data.files = []
      } catch (error) {
        console.error('Erro ao enviar:', error)
        alert('Erro ao enviar os arquivos.')
      }
    },

    deleteImageInArray (index) {
      this.category.files.splice(index, 1)
    }
  },

  mounted () {
    this.index({
      page: 1,
      name: null
    })
    this.getCoupons({
      page: 1,
      name: null
    })
  }

}

</script>
